import { Icon } from '@/components/ui/Icon'
import { formatDisplayDate } from '@/lib/date'
import { useRouteStore } from '@/store/route'
import { useNavigate } from 'react-router-dom'
import styles from './ViewReport.module.scss'

export const ViewReportPage = () => {
  const navigate = useNavigate()
  const currentDonation = useRouteStore((state) => state.currentDonation)
  const report = currentDonation?.report

  const handleBack = () => {
    navigate(-1)
  }

  if (!report) {
    return (
      <div className={styles.container} data-testid="view-report-page-empty">
        <div className={styles.content}>
          <header className={styles.header}>
            <button
              className={styles.backButton}
              onClick={handleBack}
              data-testid="view-report-back-button"
            >
              <Icon name="chevron-left" size={20} className={styles.backIcon} />
            </button>
            <h1 className={styles.headerTitle}>Report</h1>
          </header>
          <p data-testid="view-report-empty">No report found.</p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container} data-testid="view-report-page">
      <div className={styles.content}>
        {/* Header */}
        <header className={styles.header}>
          <button
            className={styles.backButton}
            onClick={handleBack}
            data-testid="view-report-back-button"
          >
            <Icon name="chevron-left" size={20} className={styles.backIcon} />
          </button>
          <h1 className={styles.headerTitle}>Report</h1>
        </header>

        {/* Report Details */}
        <Icon name="flag-report" size={32} className={styles.reportIcon} />
        <div className={styles.date} data-testid="view-report-date">
          <Icon name="calendar" size={16} />
          <span>Reported {formatDisplayDate(report.reported_at ?? '')}.</span>
        </div>
        <p className={styles.description} data-testid="view-report-description">
          {report.description}
        </p>

        {/* Photos */}
        {report.photos && report.photos.length > 0 && (
          <>
            <h3 className={styles.photosTitle}>Photos</h3>
            <div className={styles.photosGrid} data-testid="view-report-photos">
              {report.photos.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Report photo ${index + 1}`}
                  className={styles.photo}
                  data-testid={`view-report-photo-${index}`}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
